var c_url = localStorage.getItem("collection_url");
if(c_url) {
  var menuText = $('body').attr('data-top-nav');
  if(menuText){
  var html = '<div class="navbar-item header__item" data-navlink-handle="your-vehicle"><a href="'+c_url+'" class="navbar-link header__link  is-arrowless">'+menuText+'</a></div>';
  var mob_html = '<li class="mobile-menu__list-item" data-mobile-menu-navlink-handle="select-vehicle"> <div class="mobile-menu__first-level has-no-submenu" data-mobile-menu-has-toggle="false"> <input class="visuallyhidden submenu__input" type="checkbox" id="mobile-submenu-your-rig"> <label class="submenu__label " for="mobile-submenu-your-rig"> <a class="mobile-menu__item " href="'+c_url+'">'+menuText+'</a></label></div></li>';
    $('.mobile-menu__list').prepend(mob_html);
    $('.header__menu-items').prepend(html);
  }
    if($('.cart').length > 0){  
  // $('.cart__featured-links a').text(menuText);    
  $('.cart__featured-links a').text("Continue Shopping"); 
  $('.cart__featured-links a').attr('href',c_url);
     $('.cart__featured-links a').addClass('button button--primary is-within-form')  
    }
}